import { createMentionListRenderer } from '@opallabs/text-editor/src/Thread/MentionList'
import { abovePopoverZIndex } from './styles'

/**
 * Marks the mounted list. It is portaled to the body, so the pin popover needs a
 * way to tell a click on a suggestion from a click away from itself.
 */
export const MENTION_SUGGESTIONS_ATTRIBUTE = 'data-mention-suggestions'

/** @return whether an event landed inside the mention suggestion list. */
export const isInsideMentionSuggestions = (
  target: EventTarget | null
): boolean =>
  target instanceof Element &&
  target.closest(`[${MENTION_SUGGESTIONS_ATTRIBUTE}]`) !== null

/**
 * @return whether a mention suggestion list is showing anywhere. The list is
 *   mounted into the body only while it is open, so its marker's presence is the
 *   answer. Read by handlers that a keypress reaches before the list does, and
 *   that have no other way to know it is there.
 */
export const areMentionSuggestionsShowing = (): boolean =>
  document.querySelector(`[${MENTION_SUGGESTIONS_ATTRIBUTE}]`) !== null

/**
 * The document-comment mention list, mounted against this composer's caret. The
 * positioning is that surface's, and stays there — this asks only for the two
 * things a list inside a pin popover needs that a list on a page does not: a
 * z-index that clears the popover's own stacking, and the marker above.
 *
 * @param onOpenChange told whether a suggestion is showing, so the composer can
 *   keep Escape from reaching the popover while the list owns it.
 */
export const createMentionSuggestionRenderer = ({
  onOpenChange,
}: {
  onOpenChange: (open: boolean) => void
}) =>
  createMentionListRenderer({
    onMentionListOpenChange: onOpenChange,
    zIndex: abovePopoverZIndex,
    attributes: { [MENTION_SUGGESTIONS_ATTRIBUTE]: '' },
  })
